// external
import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

// internal
import { ParentalValuesService } from '../../../values/parental.values.service';
import { ConfigService } from '../../../config/config.service';
import { Outlet, OutletStatus, OutletsStatusService } from '../../../../common/services/core/outlets.status.service';
import { ModalName, ModalRoutelessService } from '../../../../common/components/ui/ui-modal-routeless/modal.routeless.service';
import { AdobeDataLayerService } from '../../../services/core/adobe.datalayer.service';

@Component({
    selector: 'app-what-can-you-do',
    templateUrl: './what-can-you-do.component.html',
    styleUrls: ['./what-can-you-do.component.scss']
})
export class WhatCanYouDoModalComponent implements OnInit, AfterViewInit {

    modal_info: any = {};
    modal_text: string = '';
    link_text: string = '';
    actions: any = {};
    listDTL: boolean = false;
    listSchedule: boolean = false;
    moreDaysChart: string = '';

    constructor(
        private readonly modalRoutelessService: ModalRoutelessService,
        private readonly location: Location,
        private readonly parentalValuesService: ParentalValuesService,
        public readonly configService: ConfigService,
        private readonly adobeDataLayerService: AdobeDataLayerService,
        private readonly outletsStatusService: OutletsStatusService,
    ) { }

    ngOnInit() {
        const modalInfo = this.modalRoutelessService.getModalInfo(ModalName.whatCanYouDoModal);
        this.modal_info = modalInfo.contentOptions;
        this.start();
    }

    ngAfterViewInit() {
        this.outletsStatusService.setStatus(Outlet.MODAL, OutletStatus.DONE);
    }

    toAddDTL() {
        event.preventDefault();
        const auxPath = this.location.path();
        if (auxPath.includes("screentime")) {
            if (auxPath.includes("history")) {
                const arrayPath = auxPath.split("/screentime");
                this.modalRoutelessService.close(arrayPath[0] + "/screentime/limits")
            } else {
                this.modalRoutelessService.close(auxPath + "/limits");
            }
        } else {
            this.modalRoutelessService.close(auxPath + "/screentime/limits")
        }
    }

    toAddSchedule() {
        event.preventDefault();
        const auxPath = this.location.path();
        if (this.actions.add_schedule && this.moreDaysChart) {
            localStorage.setItem('recommendedSchedule', this.moreDaysChart);
        }
        if (auxPath.includes("screentime")) {
            if (auxPath.includes("history")) {
                const arrayPath = auxPath.split("/screentime");
                this.modalRoutelessService.close(arrayPath[0] + "/screentime/schedule")
            } else {
                this.modalRoutelessService.close(auxPath + "/schedule");
            }
        } else {
            this.modalRoutelessService.close(auxPath + "/screentime/schedule")
        }
    }

    start() {
        this.modal_text = 'parental.screentime.whatcanyoudo.text_' + this.modal_info.text;
        this.link_text = this.adobeDataLayerService.addRefAndVisitor(this.parentalValuesService.linksWhatCanYouDo[this.modal_info.link]);
        this.actions = this.modal_info.actions;
        this.listDTL = this.modal_info.actions.hasOwnProperty('add_daily_time_limit');
        this.listSchedule = this.modal_info.actions.hasOwnProperty('add_schedule');
        this.moreDaysChart = this.modal_info.number;
    }

}
